/**
 * Billing module theme — clear blue (distinct from Patient indigo).
 *
 * Page chrome matches QA Center (`PAGE_SHELL` + bold title). Change colors
 * HERE only; tabs, sections, and action buttons resolve through these tokens.
 */

/** Brand hex (blue). */
export const BILLING_THEME_HEX = {
  brand: "#93C5FD",
  soft: "#EFF6FF",
  border: "#BFDBFE",
  strong: "#2563EB",
  text: "#1D4ED8",
  title: "#1E3A8A",
  softHover: "#DBEAFE",
};

/**
 * Tailwind utility tokens — blue.
 * Keep in sync with BILLING_THEME_HEX when adjusting brand.
 */
export const BILLING_THEME = {
  section: {
    wrap: "border-blue-200",
    head: "bg-blue-50 border-blue-100",
    bar: "bg-blue-400",
    icon: "text-blue-500",
    title: "text-blue-900",
    edit: "text-blue-700 border-blue-300 hover:bg-blue-50",
    addTone: "text-blue-700 border-blue-300 hover:bg-blue-50",
    badge: "bg-blue-100 text-blue-700",
  },

  summary: {
    bar: "bg-blue-400",
    icon: "text-blue-500",
    head: "bg-blue-50/90",
    title: "text-blue-900",
  },

  tableHead: {
    className: "bg-blue-50/70 border-blue-100 text-blue-700",
    row: "bg-blue-50/70 border-blue-100",
    cell: "text-blue-700",
    cellHover: "hover:bg-blue-100/70",
    sortActive: "text-blue-600",
  },

  tab: {
    active: "text-blue-700 bg-white",
    inactive: "text-slate-600 hover:text-slate-900 hover:bg-slate-100/80",
    underline: "bg-blue-500",
  },

  button: {
    primary:
      "bg-blue-600 text-white hover:bg-blue-700 border border-blue-600",
    outline: "text-blue-700 border-blue-300 bg-white hover:bg-blue-50",
    link: "text-blue-700 hover:underline",
    soft: "bg-blue-50 text-blue-700 border border-blue-300 hover:bg-blue-100 hover:border-blue-400",
  },

  focus: "focus:border-blue-400 focus:ring-1 focus:ring-blue-100",
  fieldFocus: "focus:border-blue-400 focus:ring-2 focus:ring-blue-100",
  menuHover: "hover:bg-blue-50",
  accentSoft: "bg-blue-50 border-blue-100 text-blue-800",
  chip: "text-blue-600 bg-blue-50 border border-blue-100",
  modalHead: "border-blue-100 bg-blue-50/70",
  modalTitle: "text-blue-900",
  rowHover: "hover:bg-blue-50/40",
  filterBorder: "border-blue-200",
  filterBar: "border-blue-100 bg-blue-50/40 text-blue-700",
};

/** Inline CSS variables for optional custom styling on a billing shell. */
export function billingThemeCssVars() {
  const h = BILLING_THEME_HEX;
  return {
    "--bl-brand": h.brand,
    "--bl-soft": h.soft,
    "--bl-border": h.border,
    "--bl-strong": h.strong,
    "--bl-text": h.text,
    "--bl-title": h.title,
    "--bl-soft-hover": h.softHover,
  };
}

export { PAGE_SHELL as BILLING_PAGE_SHELL } from "../../ui/pageChrome";
